import React from 'react'
import styled from '@emotion/styled'
import themes from 'src/styles/themes'
import { colors } from 'src/styles'
import { rgba } from 'polished'

const ThemeWrapper = styled.div`
	${ ({ 'data-theme': setTheme, isOverlay, overlayTextColor }) => setTheme && setTheme !== 'bgColor' ? `
		background-color: ${
      // if prop isOverlay, make background transparent
      isOverlay
      ? 'transparent'
      : themes[setTheme].background
    };
    color: ${ (overlayTextColor && colors[overlayTextColor]) || themes[setTheme].color };
		*::selection {
	    background: ${ rgba(themes[setTheme].color, 0.9) };
	    color: ${ themes[setTheme].background };
	  }
	` : `` }
`

const ThemeSelector = ({ className, overlayTextColor, isOverlay, setTheme = 'bgColor', ...rest }) => {
  return (
	<ThemeWrapper
		data-theme={setTheme}
    className={className}
    isOverlay={isOverlay}
    overlayTextColor={overlayTextColor}
		{...rest}
	/>
)
}

export default ThemeSelector
